module.exports = __webpack_public_path__ + "media/כתום.9c7d703f.mp3";